<div edlFocusTrap class="focus-trap-container">
    <div class="modal-header">
        <h4 class="modal-title" id="recurring-item-modal-title">View Item</h4>
        <button type="button" class="btn btn-x btn-link cancel" (click)="cancel()" aria-label="Close">
            <i class="fas fa-times" aria-hidden="true"></i>
        </button>
    </div>
    <hr class="m-0" aria-hidden="true">
    <div class="modal-body" aria-labelledby="recurring-item-modal-title">
        <div class="alert alert-info" role="status">
            This item may not need your attention yet. Any actions taken now may be premature.
        </div>
        <p>
            You have <strong class="text-success">{{ daysRemaining }}</strong> days remaining before this item is due.
        </p>
        <p>
            To review evidence or questionnaires from previous cycles, click <strong>View Previous Cycle History</strong>.
        </p>
    </div>
    <hr class="m-0" aria-hidden="true">
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary me-auto" (click)="viewHistory()">
            View Previous Cycle History &nbsp;<i class="fas fa-history" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-primary" (click)="continueToCurrent()">
            Continue to Current Cycle <i class="fas fa-arrow-right" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-info" (click)="cancel()">
            Cancel
        </button>
    </div>
</div>
